 import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { ProfileComponent } from './theme/_profile/profile.component';
import { AuthGuard } from './_services/security/auth.guard';
//import { BasicLoginComponent } from './theme/auth/login/basic-login/basic-login.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    
    children: [
      {
        path: '',
        redirectTo: 'registration',
        pathMatch: 'full'
      },      
      {
        path: 'dashboard',
     ///   canActivate: [AuthGuard],
        loadChildren: './theme/dashboard/dashboard.module#DashboardModule'
      },
       {
        path: 'registrations',
        canActivate: [AuthGuard],
         loadChildren: './theme/_registration/registration.module#RegistrationModule'
      },
      //{
      //  path: 'registration2',
      //  loadChildren: './theme/bidderapplication/bidderapplication.module#BidderapplicationModule'
      //  //loadChildren: './theme/ngx-wizard/ngx-wizard.module#NGXFormWizardModule'
      //},
      {
        path: 'registration',
        loadChildren: './theme/ngx-wizard/ngx-wizard.module#NGXFormWizardModule'
      }

    ]
  }   
  ,
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: './theme/auth/auth.module#AuthModule'
      }

    ]
  }
  , { path: '**', redirectTo: '/auth/login' }


  //, {
  //  path: 'login',
  //  component: BasicLoginComponent

  //}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  entryComponents: [ProfileComponent]

})
export class AppRoutingModule { }
